import { buildHref } from "@softmax/web-addresses";
import type { GameDestinationContext } from "@softmax/web-addresses";
import { PlaySubpageHeader } from "@softmax/product-ux/play";

export function SubpageHeader({
  leagueName,
  route,
  title,
}: {
  readonly leagueName: string;
  readonly route: GameDestinationContext;
  readonly title: string;
}) {
  return (
    <PlaySubpageHeader
      leagueName={leagueName}
      playHref={buildHref({ name: "game.play", ...route })}
      title={title}
    />
  );
}
